export default "__VITE_PUBLIC_ASSET__4b481caf__"